import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import {
  TYPE_POSITIVE,
  TYPE_NEGATIVE,
  TYPE_WARNING,
  TYPE_DISABLED,
} from '../constants';
import './index.css';

/**
 * Box main sensor
 * Display box with the main sensor data (value, unit and title)
 * parameters (props)
 * @param string value
 * @param string titleValue
 * @param string unitValue
 * @param string type
 * @param string mode
 * @param string titleAlarm: the name of the alarm to be displayed together
 *  with the icon warning sign (if present)
 */
export default class BoxMainSensor extends React.PureComponent {
  render() {
    const {
      value,
      titleValue,
      unitValue,
      type,
      mode,
      titleAlarm,
      ...otherProps
    } = this.props;
    const styleValue = {};
    const styleTitle = {};
    /* mode UI: dark mode/light mode */
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      switch (type) {
        case TYPE_POSITIVE:
          styleValue.color = modeColors.BOX_MAIN_SENSOR_COLOR_POSITIVE;
          styleTitle.color = modeColors.BOX_MAIN_SENSOR_COLOR;
          break;
        case TYPE_WARNING:
          styleValue.color = modeColors.WARNING_COLOR;
          styleTitle.color = modeColors.BOX_MAIN_SENSOR_COLOR;
          break;
        case TYPE_NEGATIVE:
          styleValue.color = modeColors.ALARM_COLOR;
          styleTitle.color = modeColors.ALARM_COLOR;
          break;
        case TYPE_DISABLED:
          styleValue.color = modeColors.DISABLE_COLOR;
          styleTitle.color = modeColors.DISABLE_COLOR;
          break;
        default:
          styleValue.color = modeColors.BOX_MAIN_SENSOR_COLOR_POSITIVE;
          styleTitle.color = modeColors.BOX_MAIN_SENSOR_COLOR;
      }
    }
    return (
      <div className="box-main-sensor" {...otherProps}>
        <div className="title" style={styleTitle}>
          {titleValue}
        </div>
        <div className="value-unit">
          <div className="value" style={styleValue}>
            {value}
          </div>
          <div className="unit" style={styleValue}>
            {unitValue}
          </div>
        </div>
        {titleAlarm && (
          <div className="icon-alarm-wrapper">
            <div className="icon-alarm">
              <Icon
                name="warning sign"
                style={{ color: styleValue.color }}
                size="small"
                key="alarms"
              />
            </div>
            <div style={styleValue}>{titleAlarm}</div>
          </div>
        )}
      </div>
    );
  }
}

BoxMainSensor.propTypes = {
  value: PropTypes.string.isRequired,
  titleValue: PropTypes.string,
  unitValue: PropTypes.string,
  type: PropTypes.string,
  mode: PropTypes.string,
  titleAlarm: PropTypes.string,
};

BoxMainSensor.defaultProps = {
  titleValue: null,
  unitValue: null,
  mode: null,
  type: TYPE_POSITIVE,
  titleAlarm: null,
};
